<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props="{ 'items-per-page-options': item_per_page_list }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t("skus") }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <button
            type="button"
            class="btn btn-info px-4 py-2 ls1 mb-2 mr-1"
            @click="() => showEditSkuModal(null)"
            :disabled="isEditable"
          >
            {{ $t("datatable_new_item") }}
          </button>
          <button
            type="button"
            class="btn btn-info px-4 py-2 ls1 mb-2"
            :disabled="isEditable"
            @click="showImportModal"
          >
            {{ $t("import") }}
          </button>
        </v-toolbar>
      </template>

      <template v-slot:item.label_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.transfer_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.bundle_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.qc_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.assemble_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.special_pack_flag="{ value }">
        {{ value === true ? $t("yes") : $t("no") }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="() => showEditSkuModal(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="() => removeSkus(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <EditSku
      ref="editSku"
      :actionFunction="editSkus"
      :carriers="carriers"
      :clientId="clientId"
      :receiving_type="receiving_type"
    ></EditSku>
    <ImportData
      ref="importData"
      :label="$t('sku')"
      :setData="setImportDataToDataTable"
      :customer="customer"
    >
    </ImportData>
  </div>
</template>

<script>
import EditSku from "@/own/components/fulfillment/asn/skuEditContainer/EditSku";
import ImportData from "@/own/components/fulfillment/asn/skuEditContainer/ImportData";
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
export default {
  name: "SkuDatatable",
  props: [
    "carriers",
    "clientId",
    "customer",
    "isEditable",
    "receiving_type",
    "item",
  ],
  components: { EditSku, ImportData },
  data: () => ({
    page: 1,
    loading: true,
    options: {},
    totalItems: 0,
    items: [],
    item_per_page_list: [50, 75, 100],
  }),
  mounted() {
    // this.updateSkus();
  },
  computed: {
    headers() {
      let headers = [
        { text: this.$t("sku_id"), value: "sku_id" },
        { text: this.$t("sku_barcode"), value: "sku_barcode" },
        { text: this.$t("batch_number"), value: "batch_number" },
        { text: this.$t("expected_quantity"), value: "expected_qty" },
        { text: this.$t("require_labeling"), value: "label_flag" },
        { text: this.$t("transfer_column"), value: "transfer_flag" },
        { text: this.$t("require_bundling"), value: "bundle_flag" },
        { text: this.$t("require_qc"), value: "qc_flag" },
        { text: this.$t("require_assembling"), value: "assemble_flag" },
        { text: this.$t("expire_date"), value: "exp_date" },
      ];
      if (this.receiving_type == "2" || this.receiving_type == "3") {
        headers.splice(3, 0, {
          text: this.$t("carton_number"),
          value: "carton_number",
        });
      } else {
        headers.splice(3, 0, {
          text: this.$t("sku_carton_number"),
          value: "carton_number",
        });
      }
      if (!this.isEditable) {
        headers.push({
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
        });
      }
      return headers;
    },
  },
  methods: {
    updateSkus() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;

      this.$store.commit(SET_PAGE_LOADING, true);
      let data = {
        id: this.item,
        page: page,
        per_page: itemsPerPage,
      };
      ApiService.post("/fulfillment/asn/asn-skus", data)
        .then((response) => {
          this.totalItems = response.data.data.total;
          this.items = response.data.data.data;
          this.resetEditForm();
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
          this.dialog = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showImportModal() {
      this.$refs.importData.toggleModal();
    },
    setImportDataToDataTable(items) {
      // this.setSku([]);
      // this.setSku(importedData);
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = {
        asn_id: this.item,
        skus: [items],
      };
      ApiService.post("/fulfillment/asn/store-asn-skus", data)
        .then(() => {
          this.updateSkus();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
      this.updateSkus();
    },
    showEditSkuModal(item) {
      if (this.isEditable) {
        return;
      }
      if (!this.customer && !this.clientId) {
        Swal.fire({
          title: "",
          text: this.$t("select_customer_for_skus"),
          icon: "warning",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        return;
      }
      this.$refs.editSku.toggleModal(item);
    },

    editSkus(item, isEdit = false) {
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = {
        asn_id: this.item,
        skus: [item],
      };
      ApiService.post("/fulfillment/asn/store-asn-skus", data)
        .then(() => {
          Swal.fire({
            title: isEdit
              ? this.$t("notificationtitle_updated")
              : this.$t("notificationtitle_created"),
            text: isEdit
              ? this.$t("item_updated_successfully", {
                  subject: this.$t("sku"),
                })
              : this.$t("item_added_successfully", {
                  subject: this.$t("sku"),
                }),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.updateSkus();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    removeSkus(item) {
      if (this.isEditable) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = {
        asn_id: this.item,
        asn_sku: item,
      };
      ApiService.post("/fulfillment/asn/destroy-asn-skus", data)
        .then(() => {
          Swal.fire({
            title: this.$t("notificationtitle_deleted"),
            text: this.$t("notificationmessage_the_data_has_been_deleted", {
              data: this.$t("sku"),
            }),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.updateSkus();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
  watch: {
    options: {
      handler() {
        this.updateSkus();
      },
      deep: true,
    },
  },
};
</script>
